import React, { useState,useEffect,useRef } from "react";
import { Dialog, Box, Grid, Card, CardContent, Typography, Button, ButtonGroup } from '@mui/material';
import { LabelValueViewModel } from "../../Types/ExportTypes";
import { useLoading, useAuth, useSnackbar } from '../../Context/Contexts';
import { useTranslation } from "react-i18next";

import { Pie, Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    ArcElement,
    Title,
    Tooltip as ChartTooltip,
    Legend,
    PointElement,
    LineElement,
    TimeScale,
    ChartOptions

} from "chart.js";

import "chartjs-adapter-date-fns";
ChartJS.register(
    CategoryScale,
    LinearScale,
    ArcElement,
    Title,
    ChartTooltip,
    Legend,
    PointElement,
    LineElement,
    TimeScale
);

const TopItemGraph: React.FC = ({

}) => {

    const [loading, setLoading] = useState(false);
    const { authService, isAuthenticated } = useAuth();
    const { showSnackbar } = useSnackbar();
    const [itemGraphData, setItemGraphData] = useState<LabelValueViewModel[]>([]);
    const [itemGraphMode, setItemGraphMode] = useState(3);
    const { t } = useTranslation();

    const initiatedRef = useRef(false);
    useEffect(() => {
        if (!initiatedRef.current) {
            initiatedRef.current = true;
            getTop10Items();
        }
    }, []);

    const getTop10ItemGraphData = (itemCollection?: LabelValueViewModel[]) => {
        const topItems = [...itemCollection ?? itemGraphData].sort((a, b) => (b.value ?? 0) - (a.value ?? 0));
 
        return {
            labels: topItems.map(item => item.label),
            datasets: [
                {
                    label: t("common.amount"),
                    data: topItems.map(item => item.value),
                    backgroundColor: topItems.map(() => "#" + Math.floor(Math.random() * 16777215).toString(16)), // Random colors
                    borderWidth: 1,
                },
            ],
        };
    }

    const [itemTop10Graph, setItemTop10Graph] = useState(getTop10ItemGraphData);

    const options: ChartOptions<"pie"> = {
        responsive: true,
        plugins: {
            legend: { position: "bottom" },
            title: { display: true, text: t("graph.itemGraphTitle") },

        },
    };



        const getTop10Items = async (graphModeOverride? : number | null) => {
            var mode = graphModeOverride ?? itemGraphMode;
            setLoading(true);
            try {
                const response = await authService.get<{ items: LabelValueViewModel[] }>(
                    `/graphApi/GetItemGraph?mode=${mode}`
                );
                setItemGraphData(prev => {



             
                    var loadGraphData = getTop10ItemGraphData(response.items);
                    setItemTop10Graph(loadGraphData);



                    return response.items;
                });


            } catch (error) {
                console.error("Failed to fetch documents:", error);
            } finally {
                setLoading(false);
            }
        };



    return (
        <>

                <Card>
                    <Box
                        sx={{
                            backgroundColor: "#fef6f0",
                            borderRadius: 2,
                            p: 3,
                        }}
                    >
                        <Typography
                            variant="h4"
                            gutterBottom
                            sx={{ display: "flex", justifyContent: "center" }}
                        >
                            {t("graph.itemGraphTitle")}
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{ color: "#4e342e", mb: 2, display: "flex", justifyContent: "center" }}
                        >
                            {t("graph.itemGraphDescription")}
                        </Typography>

                        <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
                            <ButtonGroup variant="outlined">
                                <Button
                                    onClick={() => {
                                        setItemGraphMode(1);
                                        getTop10Items(1);
                                    }}
                                    variant={itemGraphMode === 1 ? "contained" : "outlined"}
                                >
                                    {t("common.day")}
                                </Button>
                                <Button
                                    onClick={() => {
                                        setItemGraphMode(2);
                                        getTop10Items(2);
                                    }}
                                    variant={itemGraphMode === 2 ? "contained" : "outlined"}
                                >
                                    {t("common.week")}
                                </Button>
                                <Button
                                    onClick={() => {
                                        setItemGraphMode(3);
                                        getTop10Items(3);
                                    }}
                                    variant={itemGraphMode === 3 ? "contained" : "outlined"}
                                >
                                    {t("common.month")}
                                </Button>
                                <Button
                                    onClick={() => {
                                        setItemGraphMode(4);
                                        getTop10Items(4);
                                    }}
                                    variant={itemGraphMode === 4 ? "contained" : "outlined"}
                                >
                                    {t("common.year")}
                                </Button>
                            </ButtonGroup>
                        </Box>

                    <Box sx={{ height: 500, display: "flex", justifyContent: "center" }}>
                        {loading ? (
                            <Typography>Loading...</Typography>
                        ) : (
                                <Pie data={itemTop10Graph} options={options} />
                        )}
                          
                        </Box>

                        <Typography
                            variant="caption"
                            sx={{ color: "#a1887f", mt: 2, display: "flex", justifyContent: "center" }}
                        >
                            {t("graph.itemExtraInfo")}
                        </Typography>
                    </Box>
                </Card>
         
        </>
    );

};

export default TopItemGraph;
